<div id="dialogHeader">
  <div class="fullWidth">
    <div id="title" class="left">
      <h3>
        {{ this.data.title }} |
        <app-company-quoteid-header [quote]="this.data.quoteRequestState"></app-company-quoteid-header>
      </h3>
    </div>

    <div class="right">
      <mat-icon class="closeDialog" aria-hidden="false" [mat-dialog-close]="{ success: false }" aria-label="Close icon">close</mat-icon>
    </div>
  </div>

  <div id="padBottom" class="fullWidth">
    <div class="left">{{ this.term }}{{ 'month' | pluraliseUnit: this.term }}</div>

    <div class="right">
      <mat-button-toggle-group appearance="default" name="dataMode" aria-label="Font Style" value="totalCost">
        <mat-button-toggle id="totalCostToggle" value="totalCost" (click)="setTotals()">TOTAL COST</mat-button-toggle>
        <mat-button-toggle id="unitRateToggle" value="UnitRate" (click)="setUnitRate()">UNIT RATE</mat-button-toggle>
        <mat-button-toggle id="commissionToggle" value="Commission" (click)="setCommission()">COMMISSION</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>
</div>

<div class="horizontal-scroller vertical-scroller tableDiv" *ngIf="dataSourceCostAndRate">
  <table
    *ngIf="showTotalCostData() || showPerUnitData()"
    mat-table
    [dataSource]="dataSourceCostAndRate"
    matSort
    multiTemplateDataRows
    class="noselect tenders-grid"
  >
    <ng-container matColumnDef="utilityAccountNumber">
      <th mat-header-cell *matHeaderCellDef>Utility Account Number</th>
      <td mat-cell *matCellDef="let moreDetails">
        {{ moreDetails.utilityAccountNumber }}
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="energyCostTotal">
      <th mat-header-cell *matHeaderCellDef>
        Energy Cost &nbsp;
        <span *ngIf="showTotalCostData()">($)</span>
        <span *ngIf="showPerUnitData()">($/MWh)</span>
      </th>
      <td mat-cell *matCellDef="let moreDetails">
        <span *ngIf="showTotalCostData()">{{ moreDetails.energyCostTotal | number: '1.4-4' | dashIfNotDefined }}</span>
        <span *ngIf="showPerUnitData()">{{ moreDetails.energyCostPerUnit | number: '1.4-4' | dashIfNotDefined }}</span>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="capacityCostTotal">
      <th mat-header-cell *matHeaderCellDef>
        Capacity Cost &nbsp;
        <span *ngIf="showTotalCostData()">($)</span>
        <span *ngIf="showPerUnitData()">($/MWh)</span>
      </th>
      <td mat-cell *matCellDef="let moreDetails">
        <span *ngIf="showTotalCostData()">{{ moreDetails.capacityCostTotal | number: '1.4-4' | dashIfNotDefined }}</span>
        <span *ngIf="showPerUnitData()">{{ moreDetails.capacityCostPerUnit | number: '1.4-4' | dashIfNotDefined }}</span>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="nitsCostTotal">
      <th mat-header-cell *matHeaderCellDef>
        Network Integration Transmission Service (NITS) Cost&nbsp;
        <span *ngIf="showTotalCostData()">($)</span>
        <span *ngIf="showPerUnitData()">($/MWh)</span>
      </th>
      <td mat-cell *matCellDef="let moreDetails">
        <span *ngIf="showTotalCostData()">{{ moreDetails.nitsCostTotal | number: '1.4-4' | dashIfNotDefined }}</span>
        <span *ngIf="showPerUnitData()">{{ moreDetails.nitsCostPerUnit | number: '1.4-4' | dashIfNotDefined }}</span>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="otherIsoCostsTotal">
      <th mat-header-cell *matHeaderCellDef>
        Other ISO Costs&nbsp;
        <span *ngIf="showTotalCostData()">($)</span>
        <span *ngIf="showPerUnitData()">($/MWh)</span>
      </th>
      <td mat-cell *matCellDef="let moreDetails">
        <span *ngIf="showTotalCostData()">{{ moreDetails.otherIsoCostsTotal | number: '1.4-4' | dashIfNotDefined }}</span>
        <span *ngIf="showPerUnitData()">{{ moreDetails.otherIsoCostsPerUnit | number: '1.4-4' | dashIfNotDefined }}</span>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="tduCostTotal">
      <th mat-header-cell *matHeaderCellDef>
        Transmission and Distribution Utility (TDU) Cost &nbsp;
        <span *ngIf="showTotalCostData()">($)</span>
        <span *ngIf="showPerUnitData()">($/MWh)</span>
      </th>
      <td mat-cell *matCellDef="let moreDetails">
        <span *ngIf="showTotalCostData()">{{ moreDetails.tduCostTotal | number: '1.4-4' | dashIfNotDefined }}</span>
        <span *ngIf="showPerUnitData()">{{ moreDetails.tduCostPerUnit | number: '1.4-4' | dashIfNotDefined }}</span>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="rpsCostTotal">
      <th mat-header-cell *matHeaderCellDef>
        Renewable Portfolio Standards (RPS) Cost &nbsp;
        <span *ngIf="showTotalCostData()">($)</span>
        <span *ngIf="showPerUnitData()">($/MWh)</span>
      </th>
      <td mat-cell *matCellDef="let moreDetails">
        <span *ngIf="showTotalCostData()">{{ moreDetails.rpsCostTotal | number: '1.0' | dashIfNotDefined }}</span>
        <span *ngIf="showPerUnitData()">{{ moreDetails.rpsCostPerUnit | number: '1.0' | dashIfNotDefined }}</span>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="otherCostsTotal">
      <th mat-header-cell *matHeaderCellDef>
        Other Costs&nbsp;
        <span *ngIf="showTotalCostData()">($)</span>
        <span *ngIf="showPerUnitData()">($/MWh)</span>
      </th>
      <td mat-cell *matCellDef="let moreDetails">
        <span *ngIf="showTotalCostData()">{{ moreDetails.otherCostsTotal | number: '1.4-4' | dashIfNotDefined }}</span>
        <span *ngIf="showPerUnitData()">{{ moreDetails.otherCostsPerUnit | number: '1.4-4' | dashIfNotDefined }}</span>
      </td>
      <td mat-footer-cell *matFooterCellDef>
        <span class="strong">Order Total:</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="totalTotal">
      <th id="totalHeader" mat-header-cell *matHeaderCellDef>
        Total&nbsp;
        <span *ngIf="showTotalCostData()">($)</span>
        <span *ngIf="showPerUnitData()">($/MWh)</span>
      </th>
      <td mat-cell *matCellDef="let moreDetails">
        <span *ngIf="showTotalCostData() && moreDetails.totalTotal !== 0">{{ moreDetails.totalTotal | number: '1.2-2' }}</span>
        <span *ngIf="showPerUnitData() && moreDetails.totalPerUnit !== 0">{{ moreDetails.totalPerUnit | number: '1.2-2' }}</span>
        <span *ngIf="showTotalCostData() && moreDetails.totalTotal === 0">-</span>
        <span *ngIf="showPerUnitData() && moreDetails.totalPerUnit === 0">-</span>
      </td>

      <td mat-footer-cell *matFooterCellDef>
        <span class="strong" *ngIf="getTotalCost() !== 0"
          >{{ getTotalCost() | currency }}
          <span *ngIf="showPerUnitData()">/MWh</span>
        </span>
        <span class="strong" *ngIf="getTotalCost() === 0">-</span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let element; columns: this.displayedColumns"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
  </table>

  <span *ngIf="showCommissionData() && commissionStatsLoading" style="width: 100%; text-align: right">Loading Commission Data</span>
  <table
    *ngIf="showCommissionData()"
    style="width: 100%; text-align: right"
    mat-table
    [dataSource]="dataSourceCommission"
    matSort
    multiTemplateDataRows
    class="noselect tenders-grid"
  >
    <ng-container matColumnDef="month">
      <th class="commissionHeaders" mat-header-cell *matHeaderCellDef>Month</th>
      <td mat-cell *matCellDef="let months">
        <span>{{ months.Month }}</span>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>
    
    <ng-container matColumnDef="estimatedConsumptionkWh">
      <th class="commissionHeaders" mat-header-cell *matHeaderCellDef> 
        Estimated Usage &nbsp;
        <span>(kWh)</span>
      </th>
      <td mat-cell *matCellDef="let months">
        <span>{{ months.EstimatedConsumptionkWh | number: '1.4-4' | dashIfNotDefined }}</span>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="estimatedCommissionDollars">
      <th class="commissionHeaders" mat-header-cell *matHeaderCellDef>
        Estimated Commission &nbsp;
        <span>($)</span>
      </th>
      <td mat-cell *matCellDef="let months">
        <span>{{ months.EstimatedCommissionDollars | number: '1.2-2' | dashIfNotDefined }}</span>
      </td>
      <td id="totalEstimatedCommission" mat-footer-cell *matFooterCellDef class="padRight10">
        Total Estimated Commission: ${{ this.getTotalEstimatedCommission() | number: '1.2-2' | dashIfNotDefined }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actualConsumptionkWh">
      <th class="commissionHeaders" mat-header-cell *matHeaderCellDef>
        Actual Usage &nbsp;
        <span>(kWh)</span>
      </th>
      <td mat-cell *matCellDef="let months">
        <span>{{ months.ActualConsumptionkWh | number: '1.4-4' | dashIfNotDefined }}</span>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="actualCommissionDollars">
      <th class="commissionHeaders" mat-header-cell *matHeaderCellDef>
        Actual Commission &nbsp;
        <span>($)</span>
      </th>
      <td mat-cell *matCellDef="let months">
        <span>{{ months.ActualCommissionDollars | number: '1.2-2' | dashIfNotDefined }}</span>
      </td>
      <td id="totalActualCommission" mat-footer-cell *matFooterCellDef class="padRight10">
        Total Actual Commission: ${{ this.getTotalActualCommission() | number: '1.2-2' | dashIfNotDefined }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsCommission; sticky: true"></tr>
    <tr mat-row *matRowDef="let element; columns: this.displayedColumnsCommission"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumnsCommission; sticky: true"></tr>
  </table>
</div>

<div class="fullWidthSolo">
  <div class="rightSolo">
    <button id="closeBtn" mat-flat-button color="accent" type="button" mat-dialog-close>Close</button>
  </div>
</div>
